module.exports = __webpack_public_path__ + "img/79.63029740.webp";